import { Component, computed, input, output, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { VisioComponentsModule } from '@visio-ai/ui-kit'
import { FilterValue, KanbanPropertyFilter, Operator, OPERATOR_SYMBOLS, PropertyValue } from '../kanban-filters.model'

@Component({
  selector: 'app-kanban-property-filter',
  standalone: true,
  imports: [VisioComponentsModule, FormsModule],
  templateUrl: './kanban-property-filter.component.html'
})
export class KanbanPropertyFilterComponent {
  filter = input.required<KanbanPropertyFilter>()
  value = input<FilterValue>(null)

  valueChange = output<PropertyValue | null>()

  protected readonly operatorSymbols = OPERATOR_SYMBOLS

  private draftState = signal<PropertyValue | null>(null)

  protected draft = computed<PropertyValue>(() => {
    return this.draftState() ?? { operator: this.filter().operators[0], value: '' }
  })

  protected isApplied = computed(() => {
    const v = this.value()
    return !!v && typeof v === 'object' && 'operator' in v && !!(v as PropertyValue).value
  })

  protected chipLabel = computed(() => {
    const v = this.value()
    if (v && typeof v === 'object' && 'operator' in v) {
      const prop = v as PropertyValue
      if (prop.value) {
        return `${this.filter().label} ${OPERATOR_SYMBOLS[prop.operator]} ${prop.value}`
      }
    }
    return this.filter().label
  })

  protected updateDraftOperator(operator: Operator): void {
    this.draftState.update(d => ({ ...(d ?? this.draft()), operator }))
  }

  protected updateDraftValue(value: string): void {
    this.draftState.update(d => ({ ...(d ?? this.draft()), value }))
  }

  protected submit(): void {
    const d = this.draft()
    if (!d.value) return
    this.valueChange.emit({ ...d })
  }

  protected clear(): void {
    this.draftState.set(null)
    this.valueChange.emit(null)
  }
}
